export default "__VITE_ASSET__2073331f__"